<template>
  <el-container class="layout-main default">
    <el-header class="el-header header-box">
      <div class="logo-group">
        <!--<img src="@/assets/image/logo.png" alt=""/>-->
        <a :href="cosreturnurl">
          <img :src="coslogourl"  alt=""/>
        </a>
      </div>
      <div class="line"></div>
      <vg-header :project="project"></vg-header>
      <div class="r">
        <login-out></login-out>
      </div>
    </el-header>
    <el-container>
        <vg-left></vg-left>
      <el-container>
        <el-main>
          <vg-explorer></vg-explorer>
          <transition name="fade-transverse">
            <keep-alive :exclude="['pbrTenderForm','projectReviewRuleIndex', 'projectResultNotice', 'psuBmPayForm','psuServicepayForm','psuBzjPayForm','pbrCenterForm','psuBzjReturnForm','prsForm']">
              <router-view></router-view>
            </keep-alive>
          </transition>
        </el-main>
        <el-footer>
          <vg-footer></vg-footer>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
  import VgHeader from './header.vue'
  import LoginOut from './loginOut.vue'
  import VgLeft from './left.vue'
  import VgFooter from './footer.vue'
  import VgExplorer from './explorer.vue'
  import request from '@/utils/request'
  export default {
    name: 'vgmain',
    data() {
      return {
        project:{}
      }
    },
    mounted(){
    },
    computed: {
      coslogourl () {
        return this.$store.getters.uploadAddr+this.$store.getters.expertLoginUser.coslogourl
      },
      cosreturnurl () {
      return this.$store.getters.expertLoginUser.cosreturnurl
      },
      style () {
        return {
          width: `${!this.sidebar.opened ? '65' : '200'}px`
        }
      }
    },
    created() {
      if (this.$router.currentRoute.name!=='mainIndex') {
        this.$router.push({path: '/'})
      }
    },
    methods: {
    },
    components: {VgHeader,VgLeft, VgExplorer,VgFooter,LoginOut}
  };
</script>
<style lang="scss">
  @import '~@/styles/theme/theme.scss';
  .header-box{
    height: 100px !important;
    display: flex;
    align-items: center;
    text-align: center
  }
  .logo-group{
    margin-left: 30px;
    a{
      img{
        height: 50px !important;
        width: 300px !important;
      }
    }
  }
  .line{
    width: 1px;
    height: 80%;
    background: #ddd;
    margin: 10px 30px
  }
  .headerMenu{
    flex: 1
  }
  .r {
    text-align: right
  }
</style>
